const SvgDataDriven2 = (props) => (
  <>
    <path fill="none" stroke={props.p50} strokeMiterlimit={10} d="M16 16h32v32H16zM80 16h32v32H80zM144 16h32v32h-32z" />
    <circle cx={160} cy={32} r={4} fill="none" stroke={props.p50} strokeMiterlimit={10} />
    <path fill="none" stroke={props.p50} strokeMiterlimit={10} d="M16 80h32v32H16zM80 80h32v32H80zM144 80h32v32h-32z" />
    <circle cx={96.9} cy={95.67} r={4} fill="none" stroke={props.p50} strokeMiterlimit={10} />
    <circle cx={32} cy={96} r={4} fill="none" stroke={props.p50} strokeMiterlimit={10} />
    <path
      fill="none"
      stroke={props.p50}
      strokeMiterlimit={10}
      d="M16 208h32v32H16zM80 208h32v32H80zM144 208h32v32h-32z"
    />
    <circle cx={96} cy={224} r={4} fill="none" stroke={props.p50} strokeMiterlimit={10} />
    <circle cx={32} cy={224} r={4} fill="none" stroke={props.p50} strokeMiterlimit={10} />
    <path
      fill="none"
      stroke={props.p50}
      strokeMiterlimit={10}
      d="M176 368h-32v-32h32zM112 368H80v-32h32zM48 368H16v-32h32z"
    />
    <circle cx={96} cy={352} r={4} fill="none" stroke={props.p50} strokeMiterlimit={10} />
    <circle cx={160} cy={352} r={4} fill="none" stroke={props.p50} strokeMiterlimit={10} />
    <path
      fill="none"
      stroke={props.p50}
      strokeMiterlimit={10}
      d="M16 272h32v32H16zM80 272h32v32H80zM144 272h32v32h-32z"
    />
    <circle cx={96} cy={288} r={4} fill="none" stroke={props.p50} strokeMiterlimit={10} />
    <path
      fill="none"
      stroke={props.p50}
      strokeMiterlimit={10}
      d="M16 144h32v32H16zM80 144h32v32H80zM144 144h32v32h-32z"
    />
    <circle cx={160} cy={160} r={4} fill="none" stroke={props.p50} strokeMiterlimit={10} />
  </>
);

export default SvgDataDriven2;
